
export const CommonDoc = {
    id: "id", //string,
    createdDate: "createdDate", // datetime
}
